import { defineMessage, useIntl } from 'react-intl';
import { ArrowLargeRight32 } from '@packages/themes/icons';
import type { ButtonProps } from '@mui/material';
import { Button } from '../Button';

const loginLabel = defineMessage({
  id: 'slot.account.login',
  defaultMessage: 'Anmelden',
});

export const LoginButton = (props: ButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <Button {...props} endIcon={<ArrowLargeRight32 />} color="primary">
      {formatMessage(loginLabel)}
    </Button>
  );
};
